'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (formatDefinition) {
  var adTypeController = null;
  // check so it doesn't blow up if it is empty
  if (!formatDefinition) return adTypeController;

  switch (formatDefinition.medium) {
    case _constants2.default.MediumTypes.audio:
    case _constants2.default.MediumTypes.video:
      adTypeController = _prerollAdController2.default;
      break;
    case _constants2.default.MediumTypes.display:
      adTypeController = _displayAdController2.default;
      break;
    case _constants2.default.Networks.fallback:
      // fallback display ads controller
      adTypeController = _fallbackAdsController2.default;
      break;
    default:
  }
  return adTypeController;
};

var _fallbackAdsController = require('../ads/controllers/fallbackAdsController');

var _fallbackAdsController2 = _interopRequireDefault(_fallbackAdsController);

var _prerollAdController = require('../ads/controllers/prerollAdController');

var _prerollAdController2 = _interopRequireDefault(_prerollAdController);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _displayAdController = require('../ads/controllers/display/displayAdController');

var _displayAdController2 = _interopRequireDefault(_displayAdController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }